// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2668":"3ab77a7c616480c2a39b","2716":"cd6acbbdd8d58be3ac79","5876":"4d2f16b67ec9ec1e4c39","6643":"ed70aefcaa53ee3c1d53","8966":"cf8d44d449d37792d5c3"}[chunkId] + ".bundle.js";
};